import { PRODUCTS_URL } from '@/modules/market/endpoints'
import AxiosFactory from '@/entities/security/AxiosFactory'
import { GET_PRODUCT_GROUPS_URL } from '../myServices/endpoints'

export default class MarketApi {
  async getProductsGroups() {
    try {
      const response = await AxiosFactory.createAxiosInstanceWithoutToken().get(GET_PRODUCT_GROUPS_URL)
      return response.data
    } catch (e) {
      console.log('getProductsGroups error: ', e)
      // throw ApiErrorFactory.create(e);
    }
  }
  async getProducts(slug: string) {
    try {
      const response = await AxiosFactory.createAxiosInstanceWithoutToken().get(`${PRODUCTS_URL}/${slug}`)
      return response.data
    } catch (e) {
      console.log('getProducts error: ', e)
      // throw ApiErrorFactory.create(e);
    }
  }
}
